export enum Roles {
  User = 'User',
  CountryAdmin = 'CountryAdmin',
  SuperAdmin = 'SuperAdmin',
  VendorAdmin = 'VendorAdmin',
  NLBUser = 'NLBUser'
}
